import React, { useState, useEffect } from 'react';
import { useTournament } from '../hooks/useTournament';

const RoundSettings = () => {
  const { numRounds, updateRounds, teamAssignmentHistory, matchSchedule } = useTournament();

  // track if user has already seen the change-warning for current schedule
  const [warnedOnChange, setWarnedOnChange] = useState(false);

  // reset warning flag when a new schedule or assignment history is generated
  useEffect(() => {
    setWarnedOnChange(false);
  }, [teamAssignmentHistory, matchSchedule]);

  // helper to confirm only once until next schedule generation
  const confirmOnce = () => {
    if ((teamAssignmentHistory.length > 0 || matchSchedule.length > 0) && !warnedOnChange) {
      const proceed = window.confirm('Wenn Sie die Anzahl der Runden ändern, werden alle Zuweisungen neu generiert und aktuelle Daten gehen verloren. Fortfahren?');
      if (!proceed) return false;
      setWarnedOnChange(true);
    }
    return true;
  };

  const handleIncrease = () => {
    if (!confirmOnce()) return;
    updateRounds(numRounds + 1);
  };

  const handleDecrease = () => {
    if (numRounds > 1) {
      if (!confirmOnce()) return;
      updateRounds(numRounds - 1);
    }
  };

  return (
    <div className="section">
      <div className="section-header">
        <h2>Runden-Einstellungen</h2>
      </div>
      <div className="number-input-container">
        <div className="number-input-label">
          <i className="icon round-icon">🔄</i>
          <span>Anzahl der Runden:</span>
        </div>
        <div className="number-input-control">
          <button 
            className="number-control-button"
            onClick={handleDecrease}
            disabled={numRounds <= 1}
          >
            −
          </button>
          <span className="number-display">{numRounds}</span>
          <button 
            className="number-control-button"
            onClick={handleIncrease}
            disabled={numRounds >= 20}
          >
            +
          </button>
        </div>
      </div>
      <p className="info-text">
        Geben Sie an, wie viele Runden im Turnier gespielt werden. Die Teams werden 
        für jede Runde nach einem Algorithmus gemischt, der versucht, die Spielervielfalt zu maximieren.
      </p>
    </div>
  );
};

export default RoundSettings;